import { useToastStore } from '../../store/toastStore';

const STYLES = {
  success: 'bg-green-900/90 border-green-700 text-green-200',
  error:   'bg-red-900/90 border-red-700 text-red-200',
  info:    'bg-slate-800/90 border-slate-600 text-slate-200',
};

const ICONS = { success: '✓', error: '✕', info: 'ℹ' };

export default function ToastContainer() {
  const { toasts, removeToast } = useToastStore();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-2 max-w-sm w-full pointer-events-none">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`flex items-start gap-3 px-4 py-3 rounded-xl border shadow-lg pointer-events-auto
            backdrop-blur-sm animate-fade-in ${STYLES[t.type] || STYLES.info}`}
        >
          <span className="text-sm font-bold flex-shrink-0 mt-0.5">{ICONS[t.type]}</span>
          <p className="text-sm flex-1 leading-snug">{t.message}</p>
          <button
            onClick={() => removeToast(t.id)}
            className="opacity-60 hover:opacity-100 transition-opacity text-lg leading-none flex-shrink-0"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
